module.exports = __webpack_public_path__ + "ui-static/img/logo-launcher_dark.208ae021.svg";